<app-settings-card
  title="Informações do tenant"
  description="Estes dados identificam a organização nos documentos e relatórios."
  icon="fas fa-building"
>
  <div class="tenant-grid" [formGroup]="form">
    <div class="logo-column">
      <span class="field-label">Logotipo</span>
      <label
        class="logo-upload"
        for="tenant-logo"
        [class.has-logo]="logoPreview"
        [class.disabled]="disabled"
      >
        @if (logoPreview) {
          <img [src]="logoPreview" alt="Logotipo do tenant" />
          <span class="logo-overlay">
            <i class="fas fa-camera"></i> Alterar
          </span>
        } @else {
          <i class="fas fa-cloud-arrow-up"></i>
          <strong>Carregar logotipo</strong>
          <small>PNG, JPG ou WEBP · máximo 2 MB</small>
        }
      </label>
      <input
        id="tenant-logo"
        type="file"
        accept=".png,.jpg,.jpeg,.webp"
        hidden
        [disabled]="disabled"
        (change)="onLogoChange($event)"
      />
      @if (logoPreview) {
        <button
          type="button"
          class="remove-logo"
          [disabled]="disabled"
          (click)="removeLogo()"
        >
          <i class="fas fa-trash-alt"></i> Remover logotipo
        </button>
      }
    </div>

    <div class="identity-fields">
      <div class="field">
        <label for="tenant-name">Nome da organização <span>*</span></label>
        <input
          id="tenant-name"
          type="text"
          formControlName="nome"
          [readOnly]="disabled"
          placeholder="Ex.: Empresa de Segurança, Lda."
          [class.invalid]="form.controls.nome.invalid && form.controls.nome.touched"
        />
        @if (form.controls.nome.invalid && form.controls.nome.touched) {
          <small class="field-error">
            Informe um nome com pelo menos 2 caracteres.
          </small>
        }
      </div>

      <div class="field">
        <label for="tenant-nif">NIF <span>*</span></label>
        <input
          id="tenant-nif"
          type="text"
          formControlName="nif"
          [readOnly]="disabled"
          placeholder="Ex.: 5410003691"
          [class.invalid]="form.controls.nif.invalid && form.controls.nif.touched"
        />
        @if (form.controls.nif.invalid && form.controls.nif.touched) {
          <small class="field-error">
            Use entre 8 e 20 letras ou números, sem espaços.
          </small>
        }
      </div>

      <div class="identity-preview">
        <div class="preview-logo">
          @if (logoPreview) {
            <img [src]="logoPreview" alt="" />
          } @else {
            <span>{{ tenantInitials() }}</span>
          }
        </div>
        <div>
          <strong>{{ form.controls.nome.value || 'Nome da organização' }}</strong>
          <small>NIF {{ form.controls.nif.value || '—' }}</small>
        </div>
      </div>
    </div>
  </div>
</app-settings-card>
